import React from 'react';
import { BackNav, AnimatedSection } from '../../components/shared';
import { SEOHead } from '../../hooks/usePageSEO';

/**
 * Wrapper de page légale — aligné sur le design de TermsPage.jsx.
 * Background gradient noir, cartes blanches/10 arrondies, prose invertie.
 */
const LegalPageLayout = ({ title, subtitle, lastUpdated, seoTitle, seoPath, children, sections }) => (
  <main className="pt-32">
    <SEOHead title={seoTitle || title} description={subtitle || ''} path={seoPath || '/'} noindex={true} />
    <section className="py-16 bg-gradient-to-b from-black to-gray-900 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <BackNav />
        <AnimatedSection>
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-white">{title}</h1>
            {subtitle && <p className="text-gray-400 mt-4 max-w-2xl mx-auto">{subtitle}</p>}
            {lastUpdated && <p className="text-gray-500 text-sm mt-2">{lastUpdated}</p>}
          </div>
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <div className="space-y-6">
            {sections ? sections.map((s, i) => (
              <div key={i} className="bg-white/5 rounded-2xl p-6 sm:p-8 border border-white/10 hover:border-pink-500/30 transition-colors">
                <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                  {s.icon && <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-pink-500/10 text-pink-400 border border-pink-500/30">{s.icon}</span>}
                  <span>{s.title}</span>
                </h2>
                <div className="prose prose-invert max-w-none prose-p:text-gray-300 prose-li:text-gray-300 prose-strong:text-white prose-a:text-pink-400 prose-a:no-underline hover:prose-a:underline prose-h3:text-lg prose-h3:text-white prose-h3:mt-5 prose-h3:mb-2 prose-code:text-pink-300 prose-code:text-sm">
                  {s.content}
                </div>
              </div>
            )) : (
              <div className="bg-white/5 rounded-2xl p-6 sm:p-10 border border-white/10 legal-content">
                {children}
              </div>
            )}
          </div>
        </AnimatedSection>
      </div>
    </section>
  </main>
);

export default LegalPageLayout;
